import { ListFilteredConference } from 'domain/usecases/conference/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListFilteredConference implements ListFilteredConference {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListFilteredConference.Model>;

  constructor(
    url: string,
    httClient: HttpClient<ListFilteredConference.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListFilteredConference.Params,
  ): Promise<ListFilteredConference.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
